import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import React, { ReactNode } from 'react'

export interface CustomHoverTooltipProps {
    text: string
    customChildren?: ReactNode
}

const CustomHoverTooltip = ({
    text,
    customChildren,
}: CustomHoverTooltipProps) => {
    return (
        <TooltipEllipsis text={text}>
            {!!customChildren ? customChildren : <span>{text}</span>}
        </TooltipEllipsis>
    )
}

export default CustomHoverTooltip
